module.exports = __webpack_public_path__ + "static/media/andrew-moroz-music-services-edited-reduced.8219b196.jpg";